import React from "react";
import classnames from "classnames";
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardImg,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    UncontrolledTooltip
  } from "reactstrap";
  
  // core components
  import DemoNavbar from "../components/Navbars/DemoNavbar.js";
  import CardsFooter from "../components/Footers/CardsFooter.js";
  
  // index page sections
  
  class Landing extends React.Component {
    state = {};
    componentDidMount() {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.main.scrollTop = 0;
    }
    render() {
      return (
        <>
          <DemoNavbar />
          <main ref="main" className="herobanner">
            <div className="position-relative ">
              {/* shape Hero */}
              
              <section className="section section-lg pb-250 team">
                <div className="shape shape-style-1 shape-default">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
                <Container className="py-lg-md d-flex ">
                  <div className="col px-0">
                    <Row className='justify-content-center text-center'>
                      <Col>
                        <h1 className="display-3 mt-0 text-darker">
                          For His honor
                        </h1>
                        <h4 className="lead text-darker">
                          Tiqvahope aims at  Offering Elegant, Classy And Exceptional Apparel For Both Men And Women, 
                          Quality And Authentic Electronics And Accessories, Build Capacity Through Training And Inspire Hope Through Counseling And Charity.
                        </h4>
                      </Col>
                    </Row>
                  </div>
                </Container>
                {/* SVG separator */}
                {/* <div className="separator separator-bottom separator-skew">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                  >
                    <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                    />
                  </svg>
                </div> */}
              </section>
              {/* 1st Hero Variation */}
            </div>
            <section className="section section-lg pt-lg-0 mt--200 team">
              <Container>
                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row className="row-grid">
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0" style={{ height: '100%'}}>
                          <CardBody className="py-5">
                            <div className="icon icon-shape icon-shape-primary rounded-circle mb-4" style={{ backgroundColor: '#e1ad01ef', color: '#046307'}}>
                              <i className="ni ni-note-03" />
                            </div>
                            <h5 className="text-darker text-uppercase">
                              <b>Song Writing</b>
                            </h5>

                            <b className="text-darker">Psalm 45:1 AMP</b>
                            <p className="description mt-3 text-darker">
                            My heart overflows with a [a]goodly theme; I address my psalm to a King. My tongue is like the pen of a ready writer.
          
                            </p>
                            <div>
                              <Badge color="primary" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Read
                              </Badge>
                              <Badge color="primary" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Meditate
                              </Badge>
                              <Badge color="primary" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Write
                              </Badge>
                            </div>
                            <Button
                              className="mt-4 bg-white"
                              href="#pablo"
                              onClick={e => e.preventDefault()}
                              style={{ color: '#046307'}}
                            >
                              Learn more
                            </Button>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0" style={{ height: '100%'}}>
                          <CardBody className="py-5">
                            <div className="icon icon-shape icon-shape-success rounded-circle mb-4" style={{ backgroundColor: '#e1ad01ef', color: '#046307'}}>
                              <i class="fa fa-user-secret" ></i>
                            </div>
                            <h5 className="text-uppercase text-darker">
                              <b className="text-darker">Apparel</b>
                            </h5>
                            <b className="text-darker">Psalm 29:2 Msg</b>
                            <p className="description mt-3 text-darker">
                            In awe before the glory, in awe before God’s visible power. Stand at attention! Dress your best to honor him! 
                            </p>
                            <div>
                              <Badge color="success" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Bags
                              </Badge>
                              <Badge color="success" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Men's collection
                              </Badge>
                              <Badge color="success" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Jewellery
                              </Badge>
                            </div>
                            <Button
                              className="mt-4"
                              href="#pablo"
                              onClick={e => e.preventDefault()}
                              style={{ backgroundColor: '#ffffff', color: '#046307'}}
                            >
                              Learn more
                            </Button>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg="4">
                        <Card className="card-lift--hover shadow border-0" style={{ height: '100%'}}>
                          <CardBody className="py-5">
                            <div className="icon icon-shape icon-shape-warning rounded-circle mb-4" style={{ backgroundColor: '#e1ad01ef', color: '#046307'}}>
                              <i className="ni ni-headphones" />
                            </div>
                            <h5 className="text-darker text-uppercase">
                              <b>Electronics</b>
                            </h5>
                            <p className="description mt-3 text-darker">
                            Dealing in laptops, accessories, phones and peripherals.
                            </p>
                            <div>
                              <Badge color="warning" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Phones
                              </Badge>
                              <Badge color="warning" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Laptops
                              </Badge>
                              <Badge color="warning" pill className="mr-1" style={{ backgroundColor: '#e1ad01ef', color:'#046307'}}>
                                Peripherals
                              </Badge>
                            </div>
                            <Button
                              className="mt-4"
                              href="#pablo"
                              onClick={e => e.preventDefault()}
                              style={{ backgroundColor: '#ffffff', color: '#046307'}}
                            >
                              Learn more
                            </Button>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="section" name="apparel">
              <Container>
                <Row className="row-grid align-items-center">
                  <Col className="order-md-2" md="6">
                    <img
                      alt="..."
                      className="img-fluid floating"
                      src={require("../assets/img/theme/fashion.jpg")}
                    />
                    <Row className="row-grid align-items-center my-md text-darker">
                      Checkout our products:
                    <Col className="text-lg-center btn-wrapper" lg="6">
                      <Button
                        className="btn-icon-only rounded-circle"
                        color="twitter"
                        href="https://twitter.com/Tiqvahope"
                        id="tooltip475038074"
                        target="_blank"
                      >
                        <span className="btn-inner--icon">
                          <i className="fa fa-twitter" />
                        </span>
                      </Button>
                      <UncontrolledTooltip delay={0} target="tooltip475038074">
                        Follow us
                      </UncontrolledTooltip>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="facebook"
                        href="https://www.facebook.com/Tiqvahope"
                        id="tooltip837440414"
                        target="_blank"
                      >
                        <span className="btn-inner--icon">
                          <i className="fa fa-facebook-square" />
                        </span>
                      </Button>
                      <UncontrolledTooltip delay={0} target="tooltip837440414">
                        Like us
                      </UncontrolledTooltip>
                      <Button
                        className="btn-icon-only rounded-circle ml-1"
                        color="instagram"
                        href="https://www.instagram.com/tiqvahope/?hl=en"
                        id="tooltip829810202"
                        target="_blank"
                      >
                        <span className="btn-inner--icon">
                        <i className="fa fa-instagram" />
                        </span>
                      </Button>
                      <UncontrolledTooltip delay={0} target="tooltip829810202">
                        Follow us
                      </UncontrolledTooltip>
                      
                    </Col>
                    </Row>
                  </Col>
                  <Col className="order-md-1" md="6">
                    <div className="pr-md-5">
                      <div className="icon icon-lg icon-shape shadow rounded-circle mb-5 bg-white">
                      <img
                        alt="..."
                        className="img-center img-fluid"
                        src={require("../assets/img/theme/coat.png")}
                      />
                      </div>
                      <h3 className="text-darker"><b>Fashion, Design, Jewellery</b></h3>
                      <p className="text-darker">
                      Looking for uniqueness, comfort, elegance and gracefulness in a adornment?
                      Let your class meet our elegance.
                      </p>
                      <ul className="list-unstyled mt-5">
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="success"
                              >
                                <img
                                  alt="..."
                                  className="img-center img-fluid"
                                  src={require("../assets/img/theme/men.png")}
                                />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0 text-darker">
                                Men's Collection
                              </h6>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="success"
                              >
                                <img
                                  alt="..."
                                  className="img-center img-fluid"
                                  src={require("../assets/img/theme/bagicon.png")}
                                />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0 text-darker">Ladies Bags</h6>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="success"
                              >
                                <img
                                  alt="..."
                                  className="img-center img-fluid"
                                  src={require("../assets/img/theme/earrings.png")}
                                />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0 text-darker">
                                Jewellery
                              </h6>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="section" name="songwriting">
              <Container>
                <Row className="row-grid align-items-center">
                  <Col md="6">
                    <Card className="shadow border-0" style={{backgroundColor:"#046307"}}>
                      <CardImg
                        alt="..."
                        src={require("../assets/img/theme/songwriting.jpg")}
                        top
                      />
                      <blockquote className="card-blockquote">
                        <h4 className="display-3 font-weight-bold text-white">
                          Songwriting
                        </h4>
                        <ol className="fa-ul text-white">
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Songwriting</li>
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Song editing</li>
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Training</li>
                      </ol>
                      </blockquote>
                    </Card>
                  </Col>
                  <Col md="6">
                    <div className="pl-md-5 text-darker">
                      <div className="icon icon-lg icon-shape icon-shape-white shadow rounded-circle mb-5">
                      <img
                        alt="..."
                        className="img-center img-fluid"
                        src={require("../assets/img/theme/write.png")}
                      />
                      </div>
                      <h3 className="text-darker"><b>Training</b></h3>
                      <p className="lead">
                        Looking to better your song writing skills, Enroll for our song writing 
                        and editing classes for gospel music artists, churches, bands and institutions 
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            <section className="section pb-100 herotwo" name="electronics">
              <Container>
                <Row className="row-grid align-items-center">
                  <Col className="order-lg-2 ml-lg-auto" md="6">
                  <div className="pl-md-5">
                      <div className="icon icon-lg icon-shape icon-shape-white shadow rounded-circle mb-5">
                      <i className="ni ni-mobile-button" style={{color:"#046307"}} />
                      </div>
                      <p className="lead text-darker">
                        Check out our state of the art gadget lab with latest accessories, software updates and peripherals 
                      </p>
                    </div>
                  </Col>
                  <Col className="order-lg-1" lg="6">
                    <div className="d-flex px-3">
                      <div>
                        <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                          <i className="ni ni-laptop" style={{color:"#046307"}} />
                        </div>
                      </div>
                      <div className="pl-4 text-darker">
                        <h4 className="display-3 text-darker">Latest Gadgets</h4>
                        <p className="">
                          Stay connected with authentic phones and laptops.
                        </p>
                      </div>
                    </div>
                    <Card className="shadow border-0" style={{backgroundColor:"#046307"}}>
                      <CardImg
                        alt="..."
                        src={require("../assets/img/theme/computers.jpg")}
                        top
                      />
                      <blockquote className="card-blockquote">
                        
                        <h4 className="display-3 font-weight-bold text-white">
                          Electronics
                        </h4>
                        <ol className="fa-ul text-white">
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Phones</li>
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Laptops</li>
                        <li><span className="fa-li" style={{ color: '#e1ad01ef'}}><i className="fa fa-circle"></i></span>Accessories</li>
                      </ol>
                      </blockquote>
                    </Card>
                  </Col>
                </Row>
              </Container>
              {/* SVG separator */}
              
            </section>
            <section className="section section-lg" name="team">
              <Container>
                <Row className="justify-content-center text-center mb-lg text-darker">
                  <Col lg="8">
                    <h2 className="display-3  text-darker">The amazing Team</h2>
                    <p className="lead text-darker ">
                      We do business, capacity building and charity hence inspiring hope and bringing honor to God.
                    </p>
                    <p className="lead text-darker">
                      Vision: To Inspire The Right Attitude Of Christian Adornment In The Community And Invigorate An Ever Living Hope In The Lives Of Many.
                    </p>
                    <p className="lead">
                      Core values:
                    </p>
                    <h2 className="text-darker" style={{fontFamily: 'Tangerine'}}>Honesty | Integrity | Diligence | Excellence | Accountability</h2>
                      
                  </Col>
                </Row>
                <Row className="justify-content-center text-center">
                  {/* <Col className="mb-5 mb-lg-0" lg="3" md="6">
                    <div className="px-4">
                      <img
                        alt="..."
                        className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                        src={require("../assets/img/theme/team-1-800x800.jpg")}
                        style={{ width: "200px" }}
                      />
                      <div className="pt-4 text-center">
                        <h5 className="title">
                          <span className="d-block mb-1">Ryan Tompson</span>
                          <small className="h6 text-muted">Web Developer</small>
                        </h5>
                        <div className="mt-3">
                          <Button
                            className="btn-icon-only rounded-circle"
                            color="warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-twitter" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            color="warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-facebook" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            color="warning"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-dribbble" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col> */}
                  {/* <Col className="mb-5 mb-lg-0" lg="3" md="6">
                    <div className="px-4">
                      <img
                        alt="..."
                        className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                        src={require("../assets/img/theme/team-2-800x800.jpg")}
                        style={{ width: "200px" }}
                      />
                      <div className="pt-4 text-center">
                        <h5 className="title">
                          <span className="d-block mb-1">Romina Hadid</span>
                          <small className="h6 text-muted">
                            Marketing Strategist
                          </small>
                        </h5>
                        <div className="mt-3">
                          <Button
                            className="btn-icon-only rounded-circle"
                            color="primary"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-twitter" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            color="primary"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-facebook" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            color="primary"
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-dribbble" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col> */}
                  
                  <Col className="mb-5 mb-lg-0" lg="3" md="6">
                    <div className="px-4">
                      <img
                        alt="..."
                        className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                        src={require("../assets/img/theme/samuelamutuhaire.png")}
                        style={{ width: "200px" }}
                      />
                      <div className="pt-4 text-center">
                        <h5 className="title" >
                          <span className="d-block mb-1 h5" style={{color:"#e1ad01ef"}}><b>Samuel Amutuhaire</b></span>
                          <small className="h6" style={{color:"#e1ad01ef"}}>Founder and CEO</small>
                        </h5>
                        <div className="mt-3">
                          <Button
                            className="btn-icon-only rounded-circle"
                            style={{backgroundColor:"#e1ad01ef", color: '#ffffff'}}
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-twitter" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            style={{backgroundColor:"#e1ad01ef", color: '#ffffff'}}
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-facebook" />
                          </Button>
                          <Button
                            className="btn-icon-only rounded-circle ml-1"
                            style={{backgroundColor:"#e1ad01", color: '#ffffff'}}
                            href="#pablo"
                            onClick={e => e.preventDefault()}
                          >
                            <i className="fa fa-instagram" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
            
            <section className="section ">
              <Container className="pb-300">
                <Row className="text-center justify-content-center text-yellow">
                  <Col lg="10">
                    <h2 className="display-3 text-darker">Dress Your best</h2>
                    <h1 className="text-darker" style={{fontFamily: 'Tangerine'}}>
                       To honour him
                    </h1>
                  </Col>
                </Row>
                {/* <Row className="row-grid mt-5">
                  <Col lg="4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                      <i className="ni ni-settings text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Building tools</h5>
                    <p className="text-white mt-3">
                      Some quick example text to build on the card title and make
                      up the bulk of the card's content.
                    </p>
                  </Col>
                  <Col lg="4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                      <i className="ni ni-ruler-pencil text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Grow your market</h5>
                    <p className="text-white mt-3">
                      Some quick example text to build on the card title and make
                      up the bulk of the card's content.
                    </p>
                  </Col>
                  <Col lg="4">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                      <i className="ni ni-atom text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Launch time</h5>
                    <p className="text-white mt-3">
                      Some quick example text to build on the card title and make
                      up the bulk of the card's content.
                    </p>
                  </Col>
                </Row> */}
              </Container>
              {/* SVG separator */}
              {/* <div className="separator separator-bottom separator-skew zindex-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div> */}
            </section>
            <section className="section section-lg pt-lg-0 section-contact-us" name="contactus">
              <Container>
                <Row className="justify-content-center mt--300">
                  <Col lg="8">
                    <Card className="bg-gradient-secondary shadow">
                      <CardBody className="p-lg-5 text-darker">
                        <h4 className="mb-1 text-darker"><b>Get in touch with us.</b></h4>
                        <p className="mt-0">
                          We would  love to hear from you
                        </p>
                        <FormGroup
                          className={classnames("mt-5 text-darker", {
                            focused: this.state.nameFocused
                          })}
                        >
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-user-run" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Your name"
                              type="text"
                              onFocus={e => this.setState({ nameFocused: true })}
                              onBlur={e => this.setState({ nameFocused: false })}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup
                          className={classnames({
                            focused: this.state.emailFocused
                          })}
                        >
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Email address"
                              type="email"
                              onFocus={e => this.setState({ emailFocused: true })}
                              onBlur={e => this.setState({ emailFocused: false })}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup className="mb-4">
                          <Input
                            className="form-control-alternative"
                            cols="80"
                            name="name"
                            placeholder="Type a message..."
                            rows="4"
                            type="textarea"
                          />
                        </FormGroup>
                        <div>
                          <Button
                            block
                            className="btn-round"
                            size="lg"
                            type="button"
                            style={{backgroundColor:"#046307", color: '#ffffff'}}
                          >
                            Send Message
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
            {/* <Download /> */}
          </main>
          <CardsFooter />
        </>
      );
    }
  }
  
  export default Landing;
  